import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useLocation, Link } from "react-router-dom";
import { useCountryPrefix } from "../routes/useCountryPrefix"; // adjust path
import CustomImageComponent from "./CustomImageComponent";


const Navbar = ({ mainMenu }) => {

  const countryPrefix = useCountryPrefix();

  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [navbarStyle, setNavbarStyle] = useState({});
  const delta = 5;
  const scrollThreshold = 150;

  const { i18n } = useTranslation();
  const currentLang = i18n.language === "en" ? "" : i18n.language || ""; // fallback to 'en'

  useEffect(() => {

    const handleScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;

      if (Math.abs(lastScrollTop - st) <= delta) return;

      if (st > lastScrollTop) {
        // Scrolling down
        if (st > scrollThreshold) {
          setNavbarStyle({
            top: "0px",
          });
        }
      } else {
        // Scrolling up or near the top
        if (st <= scrollThreshold) {
          setNavbarStyle({
            top: "0",
            position: "unset",
            boxShadow: "none",
          });
        } else {
          setNavbarStyle({
            top: "0",
            position: "fixed",
            boxShadow: "0px 8px 16px rgba(27, 43, 124, 0.1)",
          });
        }
      }

      setLastScrollTop(st);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup scroll listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]); // Dependency on lastScrollTop to track changes

  const { t } = useTranslation();
  const location = useLocation();


  const [languageDetails, setLanguageDetails] = useState({
    expectedLang: "en",
  });

  useEffect(() => {
    const segments = location.pathname.split("/").filter(Boolean);
    if (segments[1] === "ar") {
      setLanguageDetails({ expectedLang: "en" });
    } else {
      setLanguageDetails({ expectedLang: "ar" });
    }
  }, [location.pathname]);

  // const handleLanguageSwitch = (newLang) => {
  //   const currentPath = location.pathname;
  //   const currentSearch = window.location.search;

  //   //const isNewsPage = currentPath === "/news" || currentPath.startsWith("/news/");
  //   let targetPath = currentPath === "/eg/news" || currentPath.startsWith("/eg/news/") || currentPath.startsWith("/eg/ar/news/") ? "/news" : currentPath;


  //   if (newLang === "ar" && (!currentPath.startsWith("/ar/") || !currentPath.startsWith("/ar"))) {
  //     setLanguageDetails({ expectedLang: "en" });


  //     window.location.href = `/ar${targetPath}${currentSearch}`;

  //   }
  //   else if (newLang === "en" && (currentPath.startsWith("/ar/") || currentPath.startsWith("/ar"))) {
  //     setLanguageDetails({ expectedLang: "ar" });

  //     const newPath = targetPath.replace(/^\/ar(\/)?/, '/');

  //     window.location.href = `${newPath}${currentSearch}`;
  //   }
  //   closeMobileMenu()
  // };

  const handleLanguageSwitch = (newLang) => {

    const { pathname, search } = window.location;
    const segments = pathname.split("/").filter(Boolean);
    const country = segments[0] || countryPrefix;
    let newPath = "";

    if (newLang === "ar") {
      // Add /ar after country
      if (segments[1] !== "ar") segments.splice(1, 0, "ar");
      newPath = "/" + segments.join("/");
      setLanguageDetails({ expectedLang: "en" });
    } else {
      // Remove /ar segment
      if (segments[1] === "ar") segments.splice(1, 1);
      newPath = "/" + segments.join("/");
      setLanguageDetails({ expectedLang: "ar" });
    }

    i18n.changeLanguage(newLang);
    window.location.href = `${newPath}${search}`;
  };

  const closeMobileMenu = () => {
    // const navbarCollapse = document.querySelector(".navbar-collapse");
    // if (navbarCollapse && navbarCollapse.classList.contains("show")) {
    //   navbarCollapse.classList.remove("show");
    // }

    const navbarCollapse = document.querySelector(".navbar-collapse");
    const navbarToggler = document.querySelector(".navbar-toggler");

    if (navbarCollapse?.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }

    if (navbarToggler) {
      navbarToggler.classList.add("collapsed");
      navbarToggler.setAttribute("aria-expanded", "false");
    }
  };

  const countryComingSoonModal = createPortal(
    <div
      className="modal fade country-switch-modal"
      id="navCountryComingSoonModal"
      tabIndex="-1"
      aria-labelledby="navCountryComingSoonLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog--country">
        <div className="modal-content country-switch-modal__panel">

          <div className="country-switch-modal__head">
            <button
              type="button"
              className="btn-close country-switch-modal__close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body country-switch-modal__body">

            <h2 className="country-switch-modal__title" id="navCountryComingSoonLabel">
              {t('coming_soon')}
            </h2>
            <p className="country-switch-modal__text">
              {t('coming_soon_text')}
            </p>
          </div>
          <div className="modal-footer country-switch-modal__footer">
            <button
              type="button"
              className="btn theme-btn theme-btn-secondary country-switch-modal__btn"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );

  return (
    <>
      <header className="header" style={navbarStyle}>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <div className="container-fluid d-flex align-items-center justify-content-between p-0">
              <Link className="navbar-brand" to={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}`}>
                <CustomImageComponent src={"/assets/img/logo.svg"} alt={"Home"}></CustomImageComponent>
              </Link>

              <div className="language-btn-mob d-flex d-lg-none">
                <button
                  className="nav-link language-btn"
                  onClick={() =>
                    handleLanguageSwitch(languageDetails.expectedLang)
                  }
                >
                  {t(languageDetails.expectedLang)}
                </button>


                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                {/* <div className="nav-item d-flex align-items-center d-inline-block d-lg-none">
                  <button
                    type="button"
                    className="btn p-0"
                    data-bs-toggle="modal"
                    data-bs-target="#navCountryComingSoonModal"
                    aria-label="Country switcher"
                  >
                    <img
                      className="countryChange"
                      src={`/assets/img/flags/${countryPrefix === "eg" ? "ae1.svg" : "eg1.svg"}`}
                      alt=""
                    />
                  </button>
                </div> */}
              </div>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav align-items-center ms-auto mb-2 mb-lg-0">

                  {mainMenu?.length > 0 &&
                    mainMenu?.filter(item => item.fieldName && item.fieldContent).map((item, index) => (
                      <li className="nav-item" key={index}>
                        {item.fieldType === "PATH" ? (


                          <Link
                            className={`nav-link  ${location.pathname === item.fieldContent || location.pathname === `/${countryPrefix}${currentLang ? `/${currentLang}` : ""}${item.fieldContent}` ? "active" : ""
                              }`}
                            aria-current="page"
                            to={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}${item.fieldContent === "/" ? "" : item.fieldContent}`}
                            onClick={closeMobileMenu}
                          >
                            {item.fieldName}
                          </Link>
                        ) : (<div ><a className="nav-link" href={item.fieldContent} target="_blank">{item.fieldName}</a></div>)}
                      </li>
                    ))}
                  {/* <li className="nav-item">
                  <Link
                    className={`nav-link  ${location.pathname === "/" || location.pathname === "/ar" || location.pathname === "/ar/" ? "active" : ""
                      }`}
                    aria-current="page"
                    to={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}`}
                    onClick={closeMobileMenu}
                  >
                    {t("home")}
                  </Link>
                </li>
                <li className="nav-item">

                  <Link
                    className={`nav-link ${(location.pathname.includes("/developers/") || location.pathname.includes("/developers")) ? "active" : ""
                      }`} to={`${countryPrefix}${currentLang ? `/${currentLang}` : ""}/developers`}
                    onClick={closeMobileMenu}
                  >
                    {t("developers")}

                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname.includes("/franchise") ? "active" : ""
                      }`} to={`${countryPrefix}${currentLang ? `/${currentLang}` : ""}/franchise`}
                    onClick={closeMobileMenu}
                  >
                    {t("franchise")}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname.includes("/freelancers") ? "active" : ""
                      }`} to={`${countryPrefix}${currentLang ? `/${currentLang}` : ""}/freelancers`}
                    onClick={closeMobileMenu}
                  >
                    {t("freelancers")}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link

                    className={`nav-link ${(location.pathname.includes("/news/") || location.pathname.includes("/news")) ? "active" : ""}`}
                    to={`${countryPrefix}${currentLang ? `/${currentLang}` : ""}/news`}
                    onClick={closeMobileMenu}
                  >
                    {t("news")}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname.includes("/career") ? "active" : ""
                      }`} to={`${countryPrefix}${currentLang ? `/${currentLang}` : ""}/career`}
                    onClick={closeMobileMenu}
                  >
                    {t("career")}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname.includes("/contact") ? "active" : ""
                      }`} to={`${countryPrefix}${currentLang ? `/${currentLang}` : ""}/contact`}
                    onClick={closeMobileMenu}
                  >
                    {t("contact")}
                  </Link>
                </li> */}


                  <li className="nav-item d-flex align-items-center">
                    <button
                      className="nav-link language-btn d-none d-lg-flex arabic_lang"
                      onClick={() =>
                        handleLanguageSwitch(languageDetails.expectedLang)
                      }
                    >
                      {t(languageDetails.expectedLang)}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className="nav-item d-flex align-items-center ms-3 d-none d-lg-inline-block">
              <button
                type="button"
                className="btn p-0"
                data-bs-toggle="modal"
                data-bs-target="#navCountryComingSoonModal"
                aria-label="Country switcher"
              >
                <img
                  className="countryChange"
                  src={`/assets/img/flags/${countryPrefix === "eg" ? "ae1.svg" : "eg1.svg"}`}
                  alt=""
                />
              </button>
            </div> */}
          </div>

        </nav>
      </header>
      {countryComingSoonModal}
    </>
  );
};

export default Navbar;
